<template>
  <modal :name="this.name === undefined ? 'change-service-plan-modal' : this.name"
         :width="490"
         :height="`auto`"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         @before-open="beforeOpen"
         @before-close="beforeClose"
  >
    <div class="FloatMenu md_overlay md_overlay_0 ">
      <div class="modal modal_0">
        <div class="md_content md_type2">
          <div class="popup_title">
            {{ $t('my.payment.serviceInfo.changing_plan')}}
          </div>
          <span class="md_close">
            <img
                @click="modalClose"
                src="/images/union.svg"
                alt=""
            />
          </span>
          <div class="title_desc">You can change it once a month.</div>
          <div class="range_container mt20">
            <div class="range_top">
              <PaymentTypeRadio
                  :termProps="confirmModalInfo.data.term"
                  :selectedTermProps="confirmModalInfo.data.change.selectedTerm"
                  class="mt10 mb20"
              />
            </div>
          </div>
          <div class="mt10 mb20">
            <LoadingOverlay
                :activeSyncProps="activeSync"
                :isFullPageProps="false"
            />
            <ul class="product_list_container">
              <li
                  v-for="product in confirmModalInfo.data.productList"
                  :key="product.seqProduct"
              >
                <div
                    class="product_card_container"
                    :class="product.seqProduct === confirmModalInfo.data.change.selectedProduct ? 'checked' : ''"
                >
                  <div class="top">
                    <div class="product_title txt_button_1">
                      {{product.defaultProductTitle}} {{ product.seqProduct === confirmModalInfo.data.present.selectedProduct ?
                        `- ${$t('status.using')}` : '' }}
                    </div>
                    <div>
                      <span class="mr10 txt_subtitle_1 --grey70">{{ product.defaultProductSubTitle }}</span>
                      <input
                          type="checkbox"
                          :id="product.seqProduct"
                          v-model="confirmModalInfo.data.change.selectedProduct"
                          v-bind:true-value="product.seqProduct"
                      >
                      <label :for="product.seqProduct"><span></span></label>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="left">
                      <h4>$</h4>
                      <h4>{{ product.productAmount }}</h4>
                    </div>
                    <div class="product_desc">
                      <span>
                        {{ product.defaultProductDescription }}
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <a
              @click="checkIsSamePlan"
              class="btn blue btn_basics"
          >
            {{ $t('status.confirm') }}
          </a>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import _API from '@/api';
import PaymentTypeRadio from '@/components/body/payments/comm/paymentTypeRadio';
import LoadingOverlay from "../../loadingOverlay";

export default {
  name: 'ChangeServicePlanModal',
  props: ['name'],
  data() {
    return {
      activeSync: false,
      confirmModalInfo: {
        activeSync: false,
        width: 475,
        header: 'modal.confirm.changed_service_plan.header',
        description: 'modal.confirm.changed_service_plan.description',
        confirmFunction: {
          button: 'status.confirm',
          func: () => {
            this.getRequestProductChangeToServer({
              seqProduct: this.confirmModalInfo.data.change.selectedProduct || this.confirmModalInfo.data.present.selectedProduct,
              paymentType: this.confirmModalInfo.data.change.selectedTerm.type || this.confirmModalInfo.data.present.selectedTerm.type
            });
          }, params: []
        },
        subFunction: '',
        type: 'changedServicePlan',
        data: {
          present: {
            selectedTerm: {type: 0},
            selectedProduct: false
          },
          change: {
            selectedTerm: {type: 0},
            selectedProduct: false
          },
          term: [
            {
              id: 'yearly',
              type: 3,
              trans: 'Yearly',
              sale : 'SAVE 10%'
            },
            {
              id: 'monthly',
              type: 2,
              trans: 'Monthly'
            }
          ],
          productList: []
        },
        close: true,
      }
    }
  },
  components: {
    LoadingOverlay,
    PaymentTypeRadio
  },
  methods: {
    modalClose () {
      this.confirmModalInfo.data.change.selectedTerm.type = 0;
      this.confirmModalInfo.data.change.selectedProduct = false;
      this.$modal.hide(this.name === undefined ? 'change-service-plan-modal' : this.name);
    },
    beforeOpen({params}) {
      this.confirmModalInfo.data.present.selectedTerm.type = params.paymentType;
      this.confirmModalInfo.data.present.selectedProduct = params.seqProduct;
      this.confirmModalInfo.data.change.selectedTerm.type = params.paymentType;

      this.getProductListFromServer();
    },
    beforeClose() {
      this.$emit('onClick', {
        result: false,
        data: {},
      });
    },
    checkIsSamePlan() {
      this.$modal.show('confirm-modal', this.confirmModalInfo);
    },
    getProductListFromServer() {
      this.activeSync = true;
      _API.PAYMENT.getProductList()
          .then(({data}) => {
            if (data.isSuccess) {
              this.confirmModalInfo.data.productList = data.productList;
            }
            this.activeSync = false;
          })
          .catch(() => {
            // 예기치 못한 에러입니다.
            this.$modal.show('common-alert-modal', {
              messageType: 'short',
              message: 'alert.unexpected_error'
            });
          })
    },
    getRequestProductChangeToServer({seqProduct, paymentType}) {
      this.confirmModalInfo.activeSync = true;
      const param = {
        seqProduct,
        paymentType
      };
      let rtnData = undefined;
      _API.PAYMENT.changeSubscription(param)
      .then(({data}) => {
        this.confirmModalInfo.activeSync = false;
        if (data.isSuccess) {
          this.getMyPurchaseSummaryFromServer();
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.change_completed'
          });
          this.$modal.hide(this.name === undefined ? 'change-service-plan-modal' : this.name);
        } else if (data.failedCode === 'MA2000'
            || data.failedCode === 'PAY2000'
            || data.failedCode === 'PAY2001'
            || data.failedCode === 'PAY2201'
            || data.failedCode === 'PAY2202'
            || data.failedCode === 'PAY2203'
        ) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: `alert.payError.${data.failedCode}`
          });
        } else {
          // 예기치 못한 에러입니다.
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.payError.ETC'
          });
        }

        rtnData = {
          result: data?.isSuccess,
          data: JSON.parse(JSON.stringify(data)),
        }
      })
      .catch(() => {
        // 예기치 못한 에러입니다.
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.retry_again'
        });
      })
      .finally(() => {
        this.$modal.hide('confirm-modal');
        this.$emit('onClick', rtnData);
      });
    },
    getMyPurchaseSummaryFromServer() {
      this.$emit('getMyPurchaseSummaryFromServer');
    }
  }
}
</script>
<style lang="scss" scoped>

.v--modal-overlay{
  .v--modal-box {
    overflow: unset;

    .product_list_container {
      flex-direction: column;

      .product_card_container {
        margin-right: 0;
        margin-bottom: 20px;
        padding: 24px 24px 10px 24px;
        box-sizing: border-box;
        border: 2px solid white;
        box-shadow: 0 0 0 1px var(--grey20) inset;

        .bottom {
          display: flex;

          .left {
            display: flex;
            align-items: center;
            margin: 15px 15px 15px 0;

            .unit {
              font-size: 25px;
              color: var(--grey100);
              font-weight: 600;
            }
          }

          .product_desc {
            font-size: 13px;
            display: flex;
            align-items: center;
            padding: 10px 5px;
          }
        }

        &:hover {
          border: 2px solid white;
          box-shadow: 0 0 0 1px var(--grey20) inset;
        }

        &.checked {
          border: 2px solid var(--blue70);
          box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.25);
        }

        &.disabled {
          background: var(--grey10);

          .product_title {
            background: var(--grey60);
            color: var(--white);
          }

          .bottom {
            .product_desc {
              font-size: 12px;
            }
          }
          &:hover {
            border: 2px solid white;
            box-shadow: 0 0 0 1px var(--grey20) inset;
          }
        }
      }
    }
  }
}
</style>
